import { render } from "./SpendingAnalysisSubCategory.vue?vue&type=template&id=0f650de8&scoped=true"
import script from "./SpendingAnalysisSubCategory.vue?vue&type=script&lang=js"
export * from "./SpendingAnalysisSubCategory.vue?vue&type=script&lang=js"

import "./SpendingAnalysisSubCategory.vue?vue&type=style&index=0&id=0f650de8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f650de8"]])

export default __exports__